import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/common.json';
import ru from './locales/ru/common.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { common: en },
    ru: { common: ru },
  },
  fallbackLng: 'en',
  lng: 'en',
  debug: true,  // Оставьте для логов
  interpolation: { escapeValue: false },
  ns: 'common',  // Измените на строку вместо массива (для default)
  defaultNS: 'common',
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'selected'],
  },
});

export default i18n;